module.exports = __webpack_public_path__ + "static/4-3779f8fa1bd18f2cab92a10ea1fbaf21.jpg";